import {
    DEVICE_GROUP_COLUMNS,
    ID_TYPE,
    TABLE_NAMES,
    TABLE_NAMES_WITH_FILTERS,
    usePermissions
} from "shared";

import EditGroupInline from "../Actions/dialogs/DeviceGroups/Inline/EditGroup";
import { useDeviceGroupInlineActions } from "../Actions/InlineActions";
import MainContainer from "../MainContainer";
import Table from "../Table";

const DeviceGroups = () => {
    const { isReadDeviceGroupNotAllowed } = usePermissions();

    const { inlineActions, rowData, isOpen, closeDialog } =
        useDeviceGroupInlineActions();

    return (
        <>
            <MainContainer>
                <Table
                    name={TABLE_NAMES.DeviceGroups}
                    nameForFilters={TABLE_NAMES_WITH_FILTERS.DeviceGroups}
                    hasNoPermissionToRead={isReadDeviceGroupNotAllowed}
                    initialColumns={DEVICE_GROUP_COLUMNS}
                    inlineActions={inlineActions}
                    idType={ID_TYPE.Id}
                    hasActionBar
                    hasDetails
                />
            </MainContainer>

            <EditGroupInline
                data={rowData}
                isOpen={isOpen}
                close={closeDialog}
            />
        </>
    );
};

export default DeviceGroups;
